import { Button } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'
import '../Style/blogStyle.scss'



const DeleteAction = ({ onDelete }: { onDelete: () => void }) => (
  <Button danger className="delete-button" icon={<DeleteOutlined style={{ color: '#FF6961' }} />} onClick={onDelete}>
    Delete blog post
  </Button>
)

export default DeleteAction
